// Playable fighters and arenas for the pre-run screens. Plain data: add a fighter or a map by adding an entry.
// Kit names/descriptions come from content.ts so the select screen can never drift from the real techniques.
import { WEAPONS, type WeaponId } from '../core/content';

export interface CharacterDef {
  id: string;
  name: string;
  /** short role line under the name */
  role: string;
  blurb: string;
  /** innate technique (the transform button; takes no build slot) */
  innate: WeaponId;
  /** technique the run starts with */
  start: WeaponId;
  /** base stats shown on the card (Workshop ranks add to them in a run) */
  stats: { hp: number };
}

export const CHARACTERS: readonly CharacterDef[] = [
  {
    id: 'aren', name: 'Aren Vale', role: 'Resonance-born vanguard',
    blurb: 'A Conductor whose working resonance core marks him as a target. Fights at range with homing bolts and builds Ki from every takedown to unlock his Surge Forms.',
    innate: 'surge', start: 'bolt', stats: { hp: 100 },
  },
];
/** Locked placeholder slots shown after the real roster (more Conductors are planned; nothing about them is shown). */
export const LOCKED_SLOTS = 2;

export function kitLine(id: WeaponId): { name: string; desc: string } {
  const w = WEAPONS[id];
  return { name: w.name, desc: w.desc[0] };
}

// Maps moved to the map system (src/maps/<id>/, registry src/maps/registry.ts; map select src/app/mapselect.ts).
